import {
    Box,
    Text
  } from '@chakra-ui/react';
  
  const DataBox = ({label, data, containerStyles}) => {
    return (
      <Box flex={1}>
        <Text
          color={"black"}
          marginBottom={2}
          fontFamily={"PlusJakartaSansMedium"}
          fontSize={"12px"}
          textTransform={"capitalize"}
        >
          {label}
        </Text>
        <Box
          padding={"12px"}
          borderWidth={1}
          borderColor={"grey.100"}
          borderStyle={"solid"}
          style={containerStyles}
          height={"40px"}
          borderRadius={4}
          cursor={"not-allowed"}
        >
          <Text
            color={"#000000"}
            fontFamily={"PlusJakartaSansRegular"}
            fontSize={"12px"}
          >
            {data}
          </Text>
        </Box>
      </Box>
    );
  }
  
  export default DataBox;